function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "dot-path",
  d: "M12822.928,662.059v115.4h640.5V897.742",
  transform: "translate(-12817.928 -657.059)",
  fill: "none",
  stroke: "#dbdbdb",
  strokeLinecap: "round",
  strokeWidth: 10,
  strokeDasharray: "0 20"
});
function SvgDotPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 650.499,
    height: 245.684,
    viewBox: "0 0 650.499 245.684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotPath);
export default __webpack_public_path__ + "static/media/dot-path.698affddff71b5bdc4f7be00ec63e1af.svg";
export { ForwardRef as ReactComponent };